export const designImages = [
  {
    id: 1,
    title: "Rodin's Hands",
    imageDescription: "Auguste Rodin - The Cathedral (1908)",
    image: "/images/designs/rodinHands2.jpg",
    size: "H 4-5",
    hours: "3-4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"],

  },
  {
    id: 2,
    title: "The Kiss",
    imageDescription: "Auguste Rodin - The Kiss",
    image: "/images/designs/Rodin02.jpg",
    size: "4 - 6",
    hours: "5-7",
    price: "$650 - $900",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"],
  },
  {
    id: 3,
    title: "Martyr 1",
    imageDescription: "Alexandre Falguière - Saint Tarcisius",
    image: "/images/designs/Martyr1.jpg",
    size: "H 4",
    hours: "4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 4,
    title: "Siren",
    imageDescription: "Siren",
    image: "/images/designs/Siren.jpg",
    size: "4 1/4 x 3",
    hours: "3-4",
    price: "$450",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 5,
    title: "Pagoda",
    imageDescription: "Bronze Tower from Goryeo",
    image: "/images/designs/bronzeTowerGoryeo.jpg",
    size: "H 5",
    hours: "3",
    price: "$400",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 6,
    title: "Vessel",
    imageDescription: "Spouted Vessel in the shape of a gazelle",
    image: "/images/designs/SpoutedVessel.jpg",
    size: "W 3",
    hours: "2",
    price: "$250",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 7,
    title: "The Slave",
    imageDescription: "Tamara de Lempicka - The Slave",
    image: "/images/designs/theSlave.jpg",
    size: "H 5",
    hours: "6+",
    price: "$980",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Non-Repeatable"]
  },
  {
    id: 8,
    title: "Vajra",
    imageDescription: "Vajra Bell",
    image: "/images/designs/VajraBell.jpg",
    size: "H 3 1/2",
    hours: "3",
    price: "$400",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 9,
    title: "Mask",
    imageDescription: "Andy Warhol - Man With Rabbit Mask",
    image: "/images/designs/AndyWarholManWithRabbitMask.jpg",
    size: "H 3",
    hours: "2",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"],
    status: "soldOut",
  },
  {
    id: 10,
    title: "Saturn",
    imageDescription: "Francisco Goya - Saturn Devouring His Son",
    image: "/images/designs/GoyaSaturn.jpg",
    size: "H 5",
    hours: "two day sessions required",
    price: "$900",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Non-Repeatable"]
  },
  {
    id: 11,
    title: "Pieta",
    imageDescription: "Michelangelo - Pieta",
    image: "/images/designs/MichelangeloPieta.jpg",
    size: "H 5",
    hours: "6+",
    price: "$900",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Non-Repeatable"]
  },
  {
    id: 12,
    title: "Bodhisattva 1",
    imageDescription: "Bodhisattva from Gandhara",
    image: "/images/designs/BodhisattvaFromGandhara.jpg",
    size: "H 5",
    hours: "5",
    price: "$750",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 13,
    title: "Bodhisattva 2",
    imageDescription: "Bodhisattva from Goryeo",
    image: "/images/designs/BodhisattvaFromGoryeo.jpg",
    size: "3 1/4 x 4 1/4",
    hours: "5+",
    price: "$750",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 16,
    title: "Bodhisattva 3",
    imageDescription: "Metalic Bodhisattva",
    image: "/images/designs/MetalicBodhisattva.jpg",
    size: "H 5",
    hours: "3-4",
    price: "$600",  
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 14,
    title: "Teapot",
    imageDescription: "Teapot from Goryeo",
    image: "/images/designs/TeapotFromGoryeo.jpg",
    size: "H 4",
    hours: "4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 15,
    title: "Eraserhead",
    imageDescription: "Eraserhead - Lady In The Radiator",
    image: "/images/designs/EraserheadLadyInTheRadiator.jpg",
    size: "2 5/8 x 2",
    hours: "2-3",
    price: "$250",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 17,
    title: "Against",
    imageDescription: "Hermann Heid - Untitled",
    image: "/images/designs/HermannHeidUntitled.jpg",
    size: "W 5",
    hours: "2-3",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 18,
    title: "Eye Miniature 1",
    imageDescription: "Eye Miniature 1",
    image: "/images/designs/EyeMiniature1.jpg",
    size: "2 x 1 1/2",
    hours: "3-4",
    price: "$500",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 19,
    title: "Eye Miniature 2",
    imageDescription: "Eye Miniature 2",
    image: "/images/designs/EyeMiniature2.jpg",
    size: "2 x 1 1/2",
    hours: "3-4",
    price: "$500",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 20,
    title: "Snout Hoverfly",
    imageDescription: "Arthur E. Smith - Rhyngia (1909)",
    image: "/images/designs/SnipeFly.jpg",
    size: "H 3 1/2",
    hours: "2",
    price: "$250",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 21,
    title: "Beauty Revealed",
    imageDescription: "Sarah Goodridge - Beauty Revealed",
    image: "/images/designs/BeautyRevealed.jpg",
    size: "H 2",
    hours: "2-3",
    price: "$370",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 22,
    title: "Botany 1",
    imageDescription: "Karl Blossfeldt - Botany Study 01",
    image: "/images/designs/KarlBlossfeldtBotanyStudy01.jpg",
    size: "H 2.5",
    hours: "3-4",
    price: "$450",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 23,
    title: "Botany 2",
    status: "soldOut",
    imageDescription: "Karl Blossfeldt - Botany Study 02",
    image: "/images/designs/KarlBlossfeldtBotanyStudy02.jpg",
    size: "H 2.5",
    hours: "2",
    price: "$350",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 24,
    title: "Botany 3",
    imageDescription: "Karl Blossfeldt - Botany Study 03",
    image: "/images/designs/KarlBlossfeldtBotanyStudy03.jpg",
    size: "H 2 1/2",
    hours: "3",
    price: "$350",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 25,
    title: "Botany 4",
    imageDescription: "Karl Blossfeldt - Botany Study 04",
    image: "/images/designs/KarlBlossfeldtBotanyStudy04.jpg",
    size: "H 2 1/2",
    hours: "3",
    price: "$350",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 26,
    title: "Pointing Man",
    imageDescription: "Giacometti - Pointing Man",
    image: "/images/designs/GiacomettiPointingMan.jpg",
    size: "H 6",
    hours: "1-2",
    price: "$200",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"],
    status: "soldOut",
  },
  {
    id: 27,
    title: "Falling Man",
    imageDescription: "Giacometti - Falling Man",
    image: "/images/designs/GiacomettiFallingMan.jpg",
    size: "3 x 5",
    hours: "2",
    price: "$150",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 28,
    title: "Dog",
    imageDescription: "Giacometti - Dog",
    image: "/images/designs/GiacomettiDog.jpg",
    size: "W 4",
    hours: "1-2",
    price: "$200",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 29,
    title: "Donkey",
    imageDescription: "Donkey",
    image: "/images/designs/Donkey.jpg",
    size: "1 3/4 x 3",
    hours: "1+",
    price: "$200",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 30,
    title: "Butterfly 1",
    imageDescription: "Butterfly 1",
    image: "/images/designs/Butterfly01.jpg",
    size: "3 1/4 x 2",
    hours: "1-2",
    price: "$200",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 31,
    title: "Butterfly 2",
    imageDescription: "Butterfly 2",
    image: "/images/designs/Butterfly02.jpg",
    size: "2 3/4 x 1 1/4",
    hours: "1-2",
    price: "$200",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 32,
    title: "Winged Victory",
    imageDescription: "Winged Victory",
    image: "/images/soldOut/0001.jpg",
    size: "",
    hours: "4-6",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 33,
    title: "Two-Headed Cow",
    imageDescription: "Two-Headed Cow",
    image: "/images/soldOut/0002.jpg",
    size: "",
    hours: "2-4",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 34,
    title: "Space Candy",
    imageDescription: "Space Candy",
    image: "/images/soldOut/0003.jpg",
    size: "",
    hours: "2",
    price: "",
    status: "soldOut",
    isColor: false,
  },
  {
    id: 35,
    title: "Incense Holder",
    imageDescription: "Incense Holder",
    image: "/images/soldOut/0004.jpg",
    size: "",
    hours: "4-6",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 36,
    title: "Spiral Staircase",
    imageDescription: "Spiral Staircase",
    image: "/images/soldOut/0005.jpg",
    size: "",
    hours: "2-4",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 37,
    title: "Jellyfish",
    imageDescription: "Jellyfish",
    image: "/images/soldOut/0006.jpg",
    size: "",
    hours: "2-4",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 38,
    title: "Sea Turtle",
    imageDescription: "Sea Turtle",
    image: "/images/soldOut/0007.jpg",
    size: "",
    hours: "2-4",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 39,
    title: "Stone Pagoda",
    imageDescription: "Stone Pagoda",
    image: "/images/soldOut/0008.jpg",
    size: "",
    hours: "2-4",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 40,
    title: "Salamander",
    imageDescription: "Salamander",
    image: "/images/soldOut/0009.jpg",
    size: "",
    hours: "2-4",
    price: "",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  },
  {
    id: 41,
    status: "soldOut",
    title: "Eterenal Sunshine",
    image: "/images/designs/soldout-eternalsunshine.jpg",
  },
  // {
  //   id: 42,
  //   title: "Collection 2",
  //   imageDescription: "Small figures from movies and vintage photos. *c, f : sold out",
    
  //   image: "/images/designs/SmallFigures02.jpg",
  //   size: {
  //     type: "range",
  //     dimension: "W",
  //     from: "2",
  //     to: "3.5"
  //   },
  //   hours: "2+",
  //   price: "$330 each",
  //   isColor: false,
  //   tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  // },
  // {
  //   id: 43,
  //   title: "Movements",
  //   imageDescription: "Martha Graham Movements. *a: sold out",
  //   image: "/images/designs/SmallFigures03.jpg",
  //   size: {
  //     type: "range",
  //     dimension: "H",
  //     from: "2",
  //     to: "4"
  //   },
  //   hours: "3",
  //   price: "$350 each",
  //   isColor: false,
  //   tags: ["Size Adjustable", "Design edits available", "Repeatable"]
  // },
  // {
  //   id: 44,
  //   title: "Doodles",
  //   imageDescription: "All pre-drawn animal friends show here are $80 each",
  //   image: "/images/designs/doodles1.jpg",
  //   size: {
  //     type: "range",
  //     from: "2",

  //   },
  //   hours: "1",
  //   price: "$80 each",
  //   isColor: false,
  //   tags: ["Size Adjustable", "Design edits available", "Repeatable x2"]
  // },
  // {
  //   id: 45,
  //   title: "Custom Doodles",
  //   imageDescription: "Custom doodles come with 3-5 design options and your choice of color. Make a doodle of your pet or favorite thing! ",
  //   image: "/images/designs/doodles2.jpg",
  //   size: {
  //     type: "range",
  //     dimension: "H",
  //     from: "~2",
  //   },
  //   hours: "1",
  //   price: "$130",
  //   isColor: true,
  //   tags: ["Size Adjustable", "Design edits available", "Customize Designs", "Repeatable"]
  // },
  {
    id: 46,
    title: "Moolmit Garden 1",
    imageDescription: " ",
    image: "/images/designs/moolmitGarden1.jpg",
    size: "H 3-6",
    hours: "1",
    price: "$150",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  // {
  //   id: 47,
  //   title: "Moolmit Garden 2",
  //   imageDescription: "* design H: $230 for each. $400 for the pair",
  //   image: "/images/designs/moolmitGarden2.jpg",
  //   size: "H 2-4",
  //   hours: "1-2",
  //   price: "$230",
  //   isColor: true,
  //   tags: ["Size Adjustable", "Color customizable", "Design edits available", "Repeatable" ]
  // },
  {
    id: 48,
    title: "Moolmit Garden 3",
    imageDescription: " ",
    image: "/images/designs/moolmitGarden3.jpg",
    size: "H 6-7",
    hours: "2.5",
    price: "$400",
    isColor: true,
    tags: ["Size Adjustable", "Color customizable", "Design edits available", "Repeatable" ],
    status: "soldOut",
  },
  {
    id: 49,
    title: "Butterfly 3",
    imageDescription: " ",
    status: "soldOut",
    image: "/images/designs/butterfly3.jpg",
    size: "H 3+",
    hours: "2",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 50,
    title: "Butterfly 4",
    imageDescription: " ",
    status: "soldOut",
    image: "/images/designs/butterfly4.jpg",
    size: "H 2-3",
    hours: "1",
    price: "$150 each",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  // {
  //   id: 51,
  //   title: "Eye Miniature 3",
  //   imageDescription: " ",
  //   image: "/images/designs/eye-miniature-03.jpg",
  //   size: {
  //     type: "range",
  //     dimension: "H",
  //     from: "1.5",
  //     to: "2 1/4",
  //   },
  //   hours: "3+",
  //   price: "$500",
  //   isColor: false,
  //   tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  // },
  {
    id: 52,
    title: "Floral 1",
    imageDescription: "Kazumasa Ogawa - Iris Kaempferi (1896)",
    image: "/images/designs/floral1.jpg",
    size: "H 6",
    hours: "3",
    price: "$500",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 53,
    title: "Floral 2",
    status: "soldOut",
    imageDescription: "Kazumasa Ogawa - Iris Kaempferi (1896)",
    image: "/images/designs/floral2.jpg",
    size: "H 6",
    hours: "3-4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 54,
    title: "Floral 3",
    imageDescription: "Kazumasa Ogawa - Lily (1896)",
    image: "/images/designs/floral3.jpg",
    size: "H 5",
    hours: "4",
    price: "$550",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 55,
    title: "Floral 4",
    status: "soldOut",
    imageDescription: "Kazumasa Ogawa - Lily (1896)",
    image: "/images/designs/floral4.jpg",
    size: "H 5",
    hours: "4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 56,
    title: "Floral 5",
    status: "soldOut",
    imageDescription: "Kazumasa Ogawa - Lily (1896)",
    image: "/images/designs/floral5.jpg",
    size: "H 4",
    hours: "4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 58,
    title: "Box of Absence",
    imageDescription: "Rebecca Horn - Messkasten (1970)",
    image: "/images/designs/boxofabsence.jpg",
    size: "H 4",
    hours: "4",
    status: "soldOut",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 59,
    title: "Conjunction",
    status: "soldOut",
    imageDescription: "Hans Bellmer - La Poupée (maquette pour Les jeux de la Poupée) (1938)",
    image: "/images/designs/conjunction.jpg",
    size: "H 4",
    hours: "3+",
    price: "$500",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 60,
    title: "Glass Tears",
    imageDescription: "Man Ray - Glass Tears (1932)",
    image: "/images/designs/glasstears.jpg",
    size: "H 2",
    hours: "3",
    price: "$450",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 61,
    title: "Perpetual Buddha",
    imageDescription: "Face vase in the style of Dora Maar",
    image: "/images/designs/perpetualbuddha.jpg",
    size: "H 3",
    hours: "2-3",
    price: "$400",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 62,
    title: "Perpetual Face 1",
    imageDescription: "Face vase in the style of Dora Maar",
    image: "/images/designs/perpetualFace1.jpg",
    size: "H 3",
    hours: "2-3",
    price: "$450",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 63,
    title: "Perpetual Face 2",
    status: "soldOut",
    imageDescription: "Face vase in the style of Dora Maar",
    image: "/images/designs/perpetualFace2.jpg",
    size: "H 3",
    hours: "2-3",
    price: "$450",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 64,
    title: "The Doll",
    imageDescription: "Hans Bellmer - La Poupée (1934)",
    image: "/images/designs/thedoll.jpg",
    size: "H 4",
    hours: "4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 65,
    title: "Uncanny Hand",
    imageDescription: "Jindřich Štyrský - Little Alabaster Hand (1940)",
    image: "/images/designs/uncannyhand.jpg",
    size: "H 4",
    hours: "3-4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 66,
    title: "Ungraspable",
    imageDescription: "Jindřich Štyrský - Untitled, from On the Needles of These Days (1945)",
    image: "/images/designs/ungraspable.jpg",
    size: "H 3 1/2",
    hours: "1-2",
    price: "$200",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 57,
    title: "Paul",
    imageDescription: "Richard Avedon - Paul McCartney (1967). 20% off if you get all 4",
    image: "/images/designs/beatlesPaul.jpg",
    size: "H 4",
    hours: "4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 67,
    title: "Ringo",
    imageDescription: "Richard Avedon - Ringo Starr (1967). 20% off if you get all 4",
    image: "/images/designs/beatlesRingo.jpg",
    size: "H 4",
    hours: "4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 68,
    title: "George",
    imageDescription: "Richard Avedon - George Harrison (1967). 20% off if you get all 4",
    image: "/images/designs/beatlesGeorge.jpg",
    size: "H 4",
    hours: "4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 69,
    title: "John",
    imageDescription: "Richard Avedon - John Lennon (1967). 20% off if you get all 4",
    image: "/images/designs/beatlesLennon.jpg",
    size: "H 4",
    hours: "4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 70,
    status: "soldOut",
    title: "Flower Boy",
    image: "/images/designs/soldout-flowerboy.jpg",
  },
  {
    id: 71,
    status: "soldOut",
    title: "Frame Woman",
    image: "/images/designs/soldout-framewoman.jpg",
  },
  {
    id: 72,
    status: "soldOut",
    title: "Gummo",
    image: "/images/designs/soldout-gummo.jpg",
  },
  {
    id: 73,
    status: "soldOut",
    title: "Movements",
    image: "/images/designs/soldout-movementsa.jpg",
  },
  {
    id: 75,
    title: "Dirty Harry",
    imageDescription: "Dirty Harry (1971)",
    image: "/images/designs/Dirtyharry.jpg",
    size: "H 4",
    hours: "2",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 76,
    title: "Eros",
    imageDescription: "Eros, The Dangerous Thread of Things (2004)",
    image: "/images/designs/Eros.jpg",
    size: "H 3",
    hours: "2",
    price: "$280",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
  },
 
  {
    id: 78,
    title: "Gravity",
    status: "soldOut",
    imageDescription: "Gravity (2013)",
    image: "/images/designs/Gravity.jpg",
    size: "H 3",
    hours: "+2",
    price: "$330",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 81,
    title: "Movements B",
    imageDescription: "Martha Graham - Letter to the World (1940)",
    image: "/images/designs/Movementsb.jpg",
    size: "H 3 1/2",
    hours: "2-3",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 82,
    title: "Movements C",
    imageDescription: "Martha Graham - Lamentation (1930)",
    image: "/images/designs/Movementsc.jpg",
    size: "H 3 1/2",
    hours: "2",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 83,
    title: "Movements D",
    status: "soldOut",
    imageDescription: "Martha Graham - Lamentation (1930)",
    image: "/images/designs/Movementsd.jpg",
    size: "H 3.5",
    hours: "+2",
    price: "$350",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 84,
    title: "Movements E",
    imageDescription: "Martha Graham - Lamentation (1930)",
    image: "/images/designs/Movementse.jpg",
    size: "W 3",
    hours: "2",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
    status: "soldOut",
  },
  {
    id: 43,
    title: "Nosferatu",
    imageDescription: "Nosferatu (1922)",
    image: "/images/designs/Nosferatu.jpg",
    size: "H 2",
    hours: "2",
    price: "$300",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 42,
    title: "The Motorcycle Diaries",
    imageDescription: "The Motorcycle Diaries (2004)",
    image: "/images/designs/Themotorcyclediaries.jpg",
    size: "W 4",
    hours: "2",
    price: "$280",
    status: "soldOut",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 85,
    title: "Cat Girl In The Mirror 1",
    imageDescription: "杉本一文, 本陣殺人事件, 1973.",
    image: "/images/designs/catgirlinthemirror1.jpg",
    size: "H 3.5",
    hours: "4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable", "Half-Customizable" ],
    status: "soldOut",
  },
  {
    id: 86,
    title: "Cat Girl In The Mirror 2",
    imageDescription: "杉本一文, 女王蜂, 1977.",
    image: "/images/designs/catgirlinthemirror2.jpg",
    size: "H 3.5",
    hours: "4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable", "Half-Customizable" ]
  },
  {
    id: 87,
    title: "Cat Girl In The Mirror 3",
    status: "soldOut",
    imageDescription: "本陣殺人事件, 1975. This is a semi-repeatable, half-custom design. You can choose from the variations below and request small modifications at no extra charge.",
    image: "/images/designs/catgirlinthemirror3.jpg",
    imageSecondary: "/images/designs/catGirl3Options.jpg",
    size: "H 3",
    hours: "3",
    price: "$450",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Semi-Repeatable", "Half-Customizable" ]
  },
  {
    id: 88,
    status: "soldOut",
    title: "Empty Stare",
    imageDescription: "Jacques Henri Lartigue, Poupées - Coiffure Antoine, 1932. You can choose from the variations below.",
    image: "/images/designs/emptystare.jpg",
    imageSecondary: "/images/designs/emptyStareOptions.jpg",
    size: "H 3 1/2-4",
    hours: "4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Semi-Repeatable", "Half-Customizable" ]
  },
  {
    id: 89,
    title: "Eye Miniature 3",
    status: "soldOut",
    imageDescription: "",
    image: "/images/designs/eyeminiature3.jpg",
    size: "W 3",
    hours: "+3",
    price: "$500",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 90,
    title: "Eye Miniature 4",
    imageDescription: "",
    image: "/images/designs/eyeminiature4.jpg",
    size: "W 3",
    hours: "3",
    price: "$500",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 91, 
    title: "Botany 5",
    imageDescription: "Karl Blossfeldt - Grass of Parnassus (1928)",
    image: "/images/designs/botany05.jpg",
    size: "H 2 1/2",
    hours: "3",
    price: "$350",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 92,
    title: "Chess Flower 1",
    imageDescription: "Karl Blossfeldt - Snake's Head Fritillary (1928)",
    image: "/images/designs/chessFlower01.jpg",
    size: "H 7",
    hours: "3-4",
    price: "$450",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
    status: "soldOut",
  },
  {
    id: 93,
    title: "Chess Flower 2",
    imageDescription: "Karl Blossfeldt - Snake's Head Fritillary (1928)",
    image: "/images/designs/chessFlower02.jpg",
    size: "H 6",
    hours: "3-4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 94,
    title: "Fragments",
    imageDescription: "Dora Maar - The Spiderweb (1936)",
    image: "/images/designs/fragments.jpg",
    size: "H 6.5",
    hours: "multiple sessions required",
    price: "$1500",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Non-Repeatable" ]
  },
  {
    id: 95,
    title: "Kiku 1",
    status: "soldOut",
    imageDescription: "Kazumasa Ogawa - Chrysanthemum (1896)",
    image: "/images/designs/kiku01.jpg",
    size: "H 5",
    hours: "2-3",
    price: "$450",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 96,
    title: "Kiku 2",
    status: "soldOut",
    imageDescription: "Kazumasa Ogawa - Kin-shi-shi (1986)",
    image: "/images/designs/kiku02.jpg",
    size: "H 7",
    hours: "3-4",
    price: "$600",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 97,
    title: "Lovers",
    imageDescription: "Zdzisław Beksiński - Untitled (1976)",
    image: "/images/designs/lovers.jpg",
    size: "H 4",
    hours: "4+",
    price: "$600",
    isColor: false,
    status: "soldOut",
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 98,
    title: "Mannequin",
    status: "soldOut",
    imageDescription: "Jacques Henri Lartigue - Mannequin, Paris (1931)",
    image: "/images/designs/mannequin.jpg",
    size: "H 3",
    hours: "3+",
    price: "$500",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
  {
    id: 99,
    title: "Spiderlily",
    imageDescription: "",
    image: "/images/designs/spiderlily.jpg",
    size: "H 6",
    hours: "3-4",
    price: "$550",
    isColor: false,
    tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
  },
{
  id: 100,
  title: "Kiku 3",
  status: "soldOut",
  imageDescription: "Kazumasa Ogawa - White Chrysanthemum (1896)",
  image: "/images/designs/kiku3.jpg",
  size: "H 7",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 101,
  title: "Kiku 4",
  status: "soldOut",
  imageDescription: "Kazumasa Ogawa - White Chrysanthemum (1896)",
  image: "/images/designs/kiku4.jpg",
  size: "H 7",
  hours: "2-3",
  price: "$450",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 102,
  title: "Kiku 5",
  imageDescription: "Kazumasa Ogawa - Kin-sui-ro (1896)",
  image: "/images/designs/kiku5.jpg",
  size: "H 6",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 103,
  title: "Sea Dragon",
  imageDescription: "Image size, from end to end, is 6.5 inches.",
  image: "/images/designs/seadragon.jpg",
  hours: "3-4",
  price: "$500",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 104,
  title: "Sprinter",
  status: "soldOut",
  imageDescription: "Étienne-Jules Marey - Untitled (Sprinter) (1893)",
  image: "/images/designs/sprinter.jpg",
  size: "W 6 1/2",
  hours: "3-4",
  price: "$550",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 105,
  title: "Timeprint Bird",
  status: "soldOut",
  imageDescription: "Étienne-Jules Marey - Flying pelican (1882)",
  image: "/images/designs/timeprint-bird.jpg",
  size: "W 5",
  hours: "3",
  price: "$450",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 106,
  title: "Timeprint Cat",
  imageDescription: "Étienne-Jules Marey - Falling Cat (1884)",
  image: "/images/designs/timeprint-cat.jpg",
  size: "H 5",  
  hours: "2-3",
  price: "$450",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
  status: "soldOut",
},
{
  id: 107,
  title: "White Gauze",
  imageDescription: "Robert Mapplethorpe - White Gauze (1984)",
  image: "/images/designs/whitegauze.jpg",
  size: "H 4",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 108,
  title: "Woman in Lace",
  imageDescription: "Lillian Bassman, Black and White: Mary Jane Russell, Le Pavillion, (1950)",
  image: "/images/designs/womaninlace.jpg",
  size: "H 4.5",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 109,
  title: "Baby Lily",
  imageDescription: "",
  image: "/images/designs/babyLily.jpg",
  size: "H 3-4",
  hours: "2-3",
  price: "$350",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 110,
  title: "Cloudy Rose",
  imageDescription: "",
  image: "/images/designs/cloudyRose.jpg",
  size: "H 2",
  hours: "1-2",
  price: "$300",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 111,
  title: "Glass Tears 2",
  status: "soldOut",
  imageDescription: "Man Ray - Glass Tears (1932)",
  image: "/images/designs/glassTears2.jpg",
  size: "H 2 1/2",
  hours: "2-3",
  price: "$450",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 112,
  title: "Self In Two",
  imageDescription: "Joe-Peter Witkin - Le Baiser (The Kiss) (1982)",
  image: "/images/designs/selfInTwo.jpg",
  size: "W 3.5",
  hours: "4-5",
  price: "$700",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 113,
  title: "Spider",
  status: "soldOut",
  imageDescription: "Louise Bourgeois - Maman (1996)",
  altDescription: "This design has been tattooed twice in smaller sizes previously. I’d like to do it one last time in a larger size for placements like the back or chest. For a large-scale piece (10”+), I offer a flat rate of $800 regardless of final size or session length.",
  image: "/images/designs/spider.jpg",
  size: "H 10+",
  hours: "5+",
  price: "$800",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 114,
  title: "Taihu Stone",
  status: "soldOut",
  imageDescription: "",
  image: "/images/designs/taihuStone.jpg",
  size: "H 4",
  hours: "3",
  price: "$450",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 115,
  title: "Venus Comb",
  imageDescription: "Size end-to-end is 6 inches.",
  image: "/images/designs/venusComb.jpg",
  size: "H 6",
  hours: "3-4",
  price: "$500",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 116,
  title: "Flamingo Flower",
  imageDescription: "",
  image: "/images/designs/flamingoFlower.jpg",
  size: "H 4",
  hours: "1-2",
  price: "$200 each, $350 for both",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 117,
  title: "Fox Shell",
  status: "soldOut",
  imageDescription: "",
  image: "/images/designs/FoxShell.jpg",
  size: "H 3",
  hours: "1-2",
  price: "$200",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 118,
  title: "Ginkgo Leaf",
  imageDescription: "",
  image: "/images/designs/GinkoLeaf.jpg",
  size: "H 3",
  hours: "1-2",
  price: "$200",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
  status: "soldOut",
},
{
  id: 119,
  title: "Lavender Buds",
  imageDescription: "$150 for one",
  image: "/images/designs/LavenderBuds.jpg",
  size: "H 4",
  hours: "1-2",
  price: "$200",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 120,
  title: "Lions Paw Shell",
  imageDescription: "",
  image: "/images/designs/LionsPawShell.jpg",
  size: "W 2",
  hours: "1-2",
  price: "$200",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 121,
  title: "Lotus Buds 1",
  imageDescription: "",
  image: "/images/designs/LotusBuds1.jpg",
  size: "H 4",
  hours: "2-3",
  price: "$350",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 122,
  title: "Lotus Buds 2",
  imageDescription: "",
  image: "/images/designs/LotusBuds2.jpg",
  size: "H 6",
  hours: "2-3",
  price: "$400",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 123,
  title: "Pansy",
  imageDescription: "$100 if added to another design",
  image: "/images/designs/Pansy.jpg",
  size: "H 1.5",
  hours: "1",
  price: "$150",
  status: "soldOut",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 124,
  title: "Spindel Shell",
  imageDescription: "",
  image: "/images/designs/SpindelShell.jpg",
  size: "H 3-4",
  hours: "1-2",
  price: "$200 each",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 125,
  title: "Trumpet Shell",
  status: "soldOut",
  imageDescription: "",
  image: "/images/designs/TrumpetShell.jpg",
  size: "H 2",
  hours: "1-2",
  price: "$200",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 126,
  title: "Wentletrap Shell",
  status: "soldOut",
  imageDescription: "",
  image: "/images/designs/WentletrapShell.jpg",
  size: "W 2.5",
  hours: "1-2",
  price: "$230",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ]
},
{
  id: 127,
  title: "Movements F",
  imageDescription: "Martha Graham - Lamentation (1930)",
  image: "/images/designs/Movementsf.jpg",
  size: "H 3 1/2",
  hours: "2",
  price: "$300",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 128,
  title: "Fairy Mushroom",
  imageDescription: "",
  image: "/images/designs/FairyMushroom.jpg",
  size: "H 2.5",
  hours: "1-2",
  price: "$200",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 129,
  title: "Calla Lily 1",
  imageDescription: "Recommended size for bud is H2-2.5”. Stem length is flexible.",
  image: "/images/designs/CallaLily1.jpg",
  size: "see below",
  hours: "2",
  price: "$300 each",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 130,
  title: "Calla Lily 2",
  imageDescription: "Recommended size for bud is H2-2.5”. Stem length is flexible.",
  image: "/images/designs/CallaLily2.jpg",
  size: "see below",
  hours: "2-3",
  price: "$450 each",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 131,
  title: "Calla Lily 3",
  imageDescription: "Recommended size for bud is H2-2.5”. Stem length is flexible.",
  altDescription: "Joella Haweis Bayer, Calla Lily Lamp 'Arum Lumineux’, 1927.",
  image: "/images/designs/CallaLily3.jpg",
  size: "see below",
  hours: "3-4",
  price: "$550",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 132,
  title: "Cat Woman in Box",
  imageDescription: "角田純男, 猫城記, 1980.",
  image: "/images/designs/Cat-Woman-in-Box.jpg",
  size: "H 3.5",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 133,
  title: "Cat Woman in Frame",
  imageDescription: "角田純男, 猫城記, 1980.",
  image: "/images/designs/Cat-Woman-in-Frame.jpg",
  size: "H 4",
  hours: "4-5",
  price: "$650",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 134,
  title: "Eye Jar",
  imageDescription: "Marcel Broodthaers, Eye in a Plastic Container, 1966.",
  image: "/images/designs/Eye-Jar.jpg",
  size: "H 2.5",
  hours: "2",
  price: "$300",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 135,
  title: "Forlorn Tree",
  imageDescription: "Zdzisław Beksiński, Untitled, 1979.",
  image: "/images/designs/Forlorn-Tree.jpg",
  size: "W 5",
  hours: "4",
  price: "$550",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 136,
  title: "Fox Woman",
  imageDescription: "Karel Thole, The Night Son, 1976.",
  image: "/images/designs/Fox-Woman.jpg",
  size: "W 4",
  hours: "3",
  price: "$400",
  isColor: false,
  status: "soldOut",
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 137,
  title: "Homo Rodans",
  imageDescription: "Remedios Varo, Homo Rodans, 1959.",
  image: "/images/designs/Homo-Rodans.jpg",
  size: "H 6",
  hours: "2-3",
  price: "$380",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 138,
  title: "Illusion Mirror",
  imageDescription: "Karel Thole, The Man Who Folded Himself, 1976.",
  image: "/images/designs/Illusion-Mirror.jpg",
  size: "W 4",
  hours: "4-5",
  price: "$680",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 139,
  title: "Illusion Tunnel",
  imageDescription: "Karel Thole, The Man Who Folded Himself, 1976.",
  image: "/images/designs/Illusion-Tunnel.jpg",
  size: "W 4.5",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 140,
  title: "Immovable Castle",
  imageDescription: "Rafał Olbiński, Combat on Paper, 1996.",
  image: "/images/designs/Immovable-Castle.jpg",
  size: "H 5",
  hours: "4",
  price: "$600",
  status: "soldOut",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 141,
  title: "Lake Dream 1",
  imageDescription: "Rafał Olbiński, L'ombre De La Lune, 2022.",
  image: "/images/designs/Lake-Dream-1.jpg",
  size: "W 4",
  hours: "1-2",
  price: "$250",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 142,
  title: "Lake Dream 2",
  imageDescription: "Rafał Olbiński, Swan's Glance, 2024.",
  image: "/images/designs/Lake-Dream-2.jpg",
  size: "H 4",
  hours: "2-3",
  price: "$350",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 143,
  title: "Magician Head",
  imageDescription: "村山潤一, イアラ, 1980.",
  image: "/images/designs/Magician-Head.jpg",
  size: "H 4.5",
  hours: "2-3",
  price: "$450",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 144,
  title: "Morphing Face",
  imageDescription: "杉本一文, 仮面舞踏会, 1976.",
  image: "/images/designs/Morphing-Face.jpg",
  size: "H 4",
  hours: "3",
  price: "$500",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 145,
  title: "Strawberry Flower",
  imageDescription: "",
  image: "/images/designs/Strawberry-Flower.jpg",
  size: "W 5",
  hours: "2-3",
  price: "$350",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable" ],
},
{
  id: 146,
  title: "Martyr 2",
  imageDescription: "Alexandre Falguière - Saint Tarcisius",
  image: "/images/designs/Martyr2.jpg",
  size: "H 4",
  hours: "4",
  price: "$600",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable"]
},
{
  id: 147,
  title: "Waxy Mushroom",
  imageDescription: "Weekday Special: Join my mailing list (Substack/@moolmit) and book your session on a weekday to receive the special rate of $150!",
  altDescription: "*There is a $200 session minimum. You’re welcome to purchase multiple designs, bring a friend, or use them as add-ons. There will also be a small additional discount when booking multiple designs.",
  image: "/images/designs/Waxy-Mushroom.jpg",
  size: "H 2.5",
  hours: "1-2",
  price: "$230",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable"]
},
{
  id: 148,
  title: "Bonnet Mushroom",
  imageDescription: "Weekday Special: Join my mailing list (Substack/@moolmit) and book your session on a weekday to receive the special rate of $150!",
  altDescription: "*There is a $200 session minimum. You’re welcome to purchase multiple designs, bring a friend, or use them as add-ons. There will also be a small additional discount when booking multiple designs.",
  image: "/images/designs/Bonnet-Mushroom.jpg",
  size: "H 3",
  hours: "1-2",
  price: "$230",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable"]
},
{
  id: 149,
  title: "Little Cap Mushroom",
  imageDescription: "Weekday Special: Join my mailing list (Substack/@moolmit) and book your session on a weekday to receive the special rate of $150!",
  altDescription: "*There is a $200 session minimum. You’re welcome to purchase multiple designs, bring a friend, or use them as add-ons. There will also be a small additional discount when booking multiple designs.",
  image: "/images/designs/Little-Cap-Mushroom.jpg",
  size: "H 2",
  hours: "1-2",
  price: "$200 each",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable"]
},
{
  id: 150,
  title: "Mini-Tile Type A",
  imageDescription: "Weekday Special: Join my mailing list (Substack/@moolmit) and book your session on a weekday to receive the special rate of $80!",
  altDescription: "*There is a $200 session minimum. You’re welcome to purchase multiple designs, bring a friend, or use them as add-ons. There will also be a small additional discount when booking multiple designs.",
  image: "/images/designs/Mini-Tile-type-A.jpg",
  size: "1x1",
  hours: "1",
  price: "$150 each",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable"]
},
{
  id: 151,
  title: "Mini-Tile Type B",
  imageDescription: "Weekday Special: Join my mailing list (Substack/@moolmit) and book your session on a weekday to receive the special rate of $130!",
  altDescription: "*There is a $200 session minimum. You’re welcome to purchase multiple designs, bring a friend, or use them as add-ons. There will also be a small additional discount when booking multiple designs.",
  image: "/images/designs/Mini-Tile-type-B.jpg",
  size: "1 1/4 x 1 1/4 ",
  hours: "1-2",
  price: "$200 each",
  isColor: false,
  tags: ["Size Adjustable", "Design edits available", "Repeatable"]
}
];
